<template>
    <div class="wrapper">
        <div class="row">
            <div class="col-6 approval-status">
                <div class="header">Approval status</div>
                <div class="body">
                    <span class="badge" @click="approvalStatus.handleClick" :class="approvalStatus.className">
                        {{ approvalStatus.text }}
                    </span>
                </div>
            </div>
            <div class="col-6 quality-status">
                <div class="header">Quality status</div>
                <div class="body">
                    <span class="badge" @click="qualityStatus.handleClick" :class="qualityStatus.className">
                        {{ qualityStatus.text }}
                    </span>
                </div>
            </div>
            <div class="col-6 airbnb-listing-status">
                <div class="header">Airbnb listing status</div>
                <div class="body">
                    <form-switch
                        v-if="
                            airbnbListingStatus.status === PARTNER_AIRBNB_LISTING_STATUS_LISTED ||
                            airbnbListingStatus.status === PARTNER_AIRBNB_LISTING_STATUS_UNLISTED
                        "
                        :value="airbnbListingStatus.status === PARTNER_AIRBNB_LISTING_STATUS_LISTED ? true : false"
                        :labels="{
                            checked: PARTNER_AIRBNB_LISTING_STATUS_MAPPING[PARTNER_AIRBNB_LISTING_STATUS_LISTED],
                            unchecked: PARTNER_AIRBNB_LISTING_STATUS_MAPPING[PARTNER_AIRBNB_LISTING_STATUS_UNLISTED],
                        }"
                        :width="75"
                        @input="handleAirbnbListingStatusChange"
                    />
                    <span class="badge" v-else :class="airbnbListingStatus.className">
                        {{ airbnbListingStatus.text }}
                    </span>
                </div>
            </div>
            <div class="col-6 lodgix-connection-status">
                <div class="header">Lodgix connection status</div>
                <div class="body">
                    <span
                        class="badge"
                        @click="lodgixConnectionStatus.handleClick"
                        :class="lodgixConnectionStatus.className"
                    >
                        {{ lodgixConnectionStatus.text }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Modal from '../../generic/modal/modal.vue';
import FormSwitch from '../../generic/form-switch/form-switch.vue';
import {
    PARTNER_AIRBNB_LISTING_STATUS_UNKNOWN,
    PARTNER_AIRBNB_LISTING_STATUS_NOT_CREATED,
    PARTNER_AIRBNB_LISTING_STATUS_IN_PROGRESS,
    PARTNER_AIRBNB_LISTING_STATUS_LISTED,
    PARTNER_AIRBNB_LISTING_STATUS_UNLISTED,
    PARTNER_AIRBNB_LISTING_STATUS_MAPPING,
    PARTNER_AIRBNB_APPROVAL_STATUS_NOT_CREATED,
    PARTNER_AIRBNB_APPROVAL_STATUS_CREATED,
    PARTNER_AIRBNB_APPROVAL_STATUS_REVIEW,
    PARTNER_AIRBNB_APPROVAL_STATUS_APPROVED,
    PARTNER_AIRBNB_APPROVAL_STATUS_REJECTED,
    PARTNER_AIRBNB_APPROVAL_STATUS_MAPPING,
    PARTNER_AIRBNB_QUALITY_STATUS_UNKNOWN,
    PARTNER_AIRBNB_QUALITY_STATUS_GOOD,
    PARTNER_AIRBNB_QUALITY_STATUS_WARN,
    PARTNER_AIRBNB_QUALITY_STATUS_SUSPEND,
    PARTNER_AIRBNB_QUALITY_STATUS_MAPPING,
    PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_NOT_CONNECTED,
    PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_SYNC_EVERYTHING,
    PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_LIMITED_SYNC,
    PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_MAPPING,
} from './constants';
export default {
    components: {
        FormSwitch,
        Modal,
    },
    data() {
        return {
            PARTNER_AIRBNB_LISTING_STATUS_LISTED,
            PARTNER_AIRBNB_LISTING_STATUS_UNLISTED,
            PARTNER_AIRBNB_LISTING_STATUS_MAPPING,
            PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_NOT_CONNECTED,
            PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_SYNC_EVERYTHING,
            PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_LIMITED_SYNC,
            PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_MAPPING,
        };
    },
    computed: {
        feedShare() {
            return this.params.data;
        },
        airbnbListingStatus() {
            const status = this.feedShare.airbnb_listing_status.status;
            const text = PARTNER_AIRBNB_LISTING_STATUS_MAPPING[status];
            let className = '';
            if (
                status === PARTNER_AIRBNB_LISTING_STATUS_NOT_CREATED ||
                status === PARTNER_AIRBNB_LISTING_STATUS_UNKNOWN
            ) {
                className = 'dark';
            } else if (status === PARTNER_AIRBNB_LISTING_STATUS_IN_PROGRESS) {
                className = 'default';
            }
            return {
                status,
                text,
                className,
            };
        },
        approvalStatus() {
            const status = this.feedShare.airbnb_status.status;
            const text = PARTNER_AIRBNB_APPROVAL_STATUS_MAPPING[status];
            let className = '';
            if (status === PARTNER_AIRBNB_APPROVAL_STATUS_NOT_CREATED) {
                className = 'dark';
            } else if (
                status === PARTNER_AIRBNB_APPROVAL_STATUS_CREATED
            ) {
                className = 'default';
            } else if (status === PARTNER_AIRBNB_APPROVAL_STATUS_APPROVED) {
                className = 'green';
            } else if (status === PARTNER_AIRBNB_APPROVAL_STATUS_REJECTED) {
                className = 'red active';
            }
            const handleClick =
                status === PARTNER_AIRBNB_APPROVAL_STATUS_REJECTED ? this.handleRejectedClick : () => {};
            return { status, text, className, handleClick };
        },
        qualityStatus() {
            const status = this.feedShare.airbnb_quality_standard.status;
            const text = PARTNER_AIRBNB_QUALITY_STATUS_MAPPING[status];
            let className = '';
            if (status === PARTNER_AIRBNB_QUALITY_STATUS_UNKNOWN) {
                className = 'dark';
            } else if (status === PARTNER_AIRBNB_QUALITY_STATUS_GOOD) {
                className = 'green';
            } else if (status === PARTNER_AIRBNB_QUALITY_STATUS_WARN) {
                className = 'yellow active';
            } else if (status === PARTNER_AIRBNB_QUALITY_STATUS_SUSPEND) {
                className = 'red active';
            }
            let handleClick = () => {};
            if (status === PARTNER_AIRBNB_QUALITY_STATUS_WARN) handleClick = this.handleNeedsAttentionClick;
            else if (status === PARTNER_AIRBNB_QUALITY_STATUS_SUSPEND) handleClick = this.handleSuspendedClick;
            return { status, text, className, handleClick };
        },
        lodgixConnectionStatus() {
            const calendarFeedOnly = this.feedShare.calendar_feed_only;
            let status;
            if (this.feedShare.remote_id === null) {
                status = PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_NOT_CONNECTED;
            } else if (calendarFeedOnly === 0) {
                status = PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_SYNC_EVERYTHING;
            } else {
                status = PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_LIMITED_SYNC;
            }
            const text = PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_MAPPING[status];
            let className = '';
            if (status === PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_NOT_CONNECTED) {
                className = 'dark';
            } else if (
                status === PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_SYNC_EVERYTHING ||
                status === PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_LIMITED_SYNC
            ) {
                className = 'green active';
            }
            const handleClick =
                status === PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_SYNC_EVERYTHING ||
                status === PARTNER_AIRBNB_LODGIX_CONNECTION_STATUS_LIMITED_SYNC
                    ? this.handleLodgixConnectionStatusClick
                    : () => {};
            return { status, text, className, handleClick };
        },
    },
    methods: {
        handleAirbnbListingStatusChange(value) {
            this.params.onAirbnbListingStatusChange &&
                this.params.onAirbnbListingStatusChange(this.params.node, this.feedShare, value);
        },
        handleRejectedClick() {
            this.params.onRejectedClick && this.params.onRejectedClick(this.feedShare);
        },
        handleNeedsAttentionClick() {
            this.params.onNeedsAttentionClick && this.params.onNeedsAttentionClick(this.feedShare);
        },
        handleSuspendedClick() {
            this.params.onSuspendedClick && this.params.onSuspendedClick(this.feedShare);
        },
        handleLodgixConnectionStatusClick() {
            this.params.onLodgixConnectionStatusClick &&
                this.params.onLodgixConnectionStatusClick(
                    this.params.node,
                    this.feedShare,
                    this.lodgixConnectionStatus.status
                );
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/mixins/_breakpoints.scss';
.wrapper {
    padding: 10px;
    padding-left: 60px;
    .header {
        color: #717171;
        text-transform: uppercase;
        font-weight: 600;
        font-size: 12px;
        white-space: wrap;
    }
    .body {
        margin-top: 5px;
    }
    .badge {
        font-size: 12px;
        line-height: 17px;
        font-weight: 500;
        padding-bottom: 1.75px;
        padding-top: 1.75px;
        padding-left: 8.75px;
        padding-right: 8.75px;
        border-radius: 99999px;
        max-width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .badge.green {
        background-color: #def7ec;
        color: #03543f;
    }
    .badge.dark {
        background-color: rgb(243, 244, 246);
        color: rgb(31, 41, 55);
    }
    .badge.red {
        background-color: rgb(253, 232, 232);
        color: rgb(155, 28, 28);
    }
    .badge.yellow {
        background-color: rgb(253, 246, 178);
        color: rgb(114, 59, 19);
    }
    .badge.default {
        background-color: rgb(225, 239, 254);
        color: rgb(30, 66, 159);
    }
}
.row {
    margin-top: -10px;
    & > * {
        margin-top: 10px;
    }
}
.active {
    text-decoration: underline;
    cursor: pointer;
}
@media screen and (min-width: 850px) {
    .approval-status {
        flex: 0 0 250px !important;
    }
    .quality-status {
        flex: 0 0 140px !important;
    }
    .airbnb-listing-status {
        flex: 0 0 180px !important;
    }
    .lodgix-connection-status {
        flex: 0 0 215px !important;
    }
}
</style>
